import styled from 'styled-components';

import { Description as FeaturePreviewDescription } from '@web/premiumGuard/featurePreview/featurePreview.styles';

export const Wrapper = styled.section`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  // @INFO styled premium guard sets up 0.5 opacity
  & > div > div {
    opacity: 1;
  }
`;

export const ImageWrapper = styled.div`
  margin-bottom: 40px;
`;

export const Description = styled(FeaturePreviewDescription)`
  margin-top: 10px;
  max-width: 400px;
  text-align: center;
`;
